// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"fa7de06a","59":"08695a03","63":"aa2519f3","220":"a5e9a534","402":"4927142a","416":"e65e6261","662":"87155034","721":"184a4a0e","787":"c0d83121","857":"73b40f93","892":"35034a75","894":"fa9e9654"}[chunkId] + ".chunk.js";
};